import type { ISchemaItem } from '-/Base/BdForm'
import type { ExtractPropTypes, PropType } from 'vue'

export interface ConditionItem extends ISchemaItem {
  atom?: any
}
export type ConditionBoxConfig = ConditionItem[]
export const conditionBoxProps = {
  config: {
    type: Array as PropType<ConditionItem[]>,
    default: () => []
  },
  block: {
    type: Boolean as PropType<boolean>,
    default: false
  }
}
export type ConditionBoxProps = ExtractPropTypes<typeof conditionBoxProps>
